import React, {Component} from 'react';
import {connect} from 'react-redux';
import { destroySession } from '../../../redux/actions/globalActions';
import { withRouter} from 'react-router-dom';

class Logout extends Component {


    componentDidMount() {
       
        localStorage.removeItem('scopedSearchData');
        localStorage.removeItem('searchScope');
        this.props.destroySession();
        this.props.history.push('/login');
        setTimeout(function() { window.location.reload() }, 200);



    }

    render() {
        return <div></div>
    }
}



function mapStateToProps (state) {
    return {

    }
}
const mapDispatchToProps = (dispatch) => {
    return {
        destroySession : () => dispatch(destroySession())
    };
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(Logout));



// WEBPACK FOOTER //
// ./src/components/User/Logout/index.js